<template>
<div class="orbit-holder">
  <div class="container-fluid orbit">
    <div class="wema c-pointer"></div>
    <div class="vectorone-outline-1">
      <div class="vectorone"></div>
    </div>
    <div class="vectorfive-outline-1">
      <div class="vectorfive">
        <div class="vectorfive-circle">
          <div class="vectorfive-inner"></div>
        </div>
      </div>
    </div>
    <div class="Vectortwo-outline-1">
      <div class="Vectortwo"></div>
    </div>
    <div class="Vectorthree-outline-1">
      <div class="Vectorthree"></div>
    </div>
    <div class="Vectorfour-outline-1">
      <div class="Vectorfour"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  setup() {},
};
</script>

<style scoped>

/* .orbit-holder {
  border: 1px solid red;
  height: 300px;
  position: relative;
}

.orbit {
  position: absolute;
} */
.wema {
  height: 90px;
  width: 90px;
  background-image: url(../../assets/wema-faith/Alatfaithlanding.png);
  background-size: cover;
  border-radius: 50%;
  /* box-shadow: -4px 2px 56px #f5eee2; */
  position: absolute;
  left: 50%;
  top: 50%;
  cursor: pointer;
  transform: translate(-50%, -50%);
}

.wema:hover {
  cursor: pointer;
  animation: orbit20 5s linear infinite;
}
@keyframes orbit20 {
  from {
    transform: rotate(0deg) translateX(100px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(100px) rotate(-360deg);
  }
}

.vectorone {
  height: 40px;
  width: 40px;
  background-image: url(../../assets/wema-faith/Vectorone.svg);
  background-size: 100%;
  color: #900a39;
  /* border-radius: 50%; */
  position: absolute;
  left: 40%;
  top: 42%;
  /* box-shadow: -4px 2px 56px #c6c6c6; */
  transform: translate(-50%, -50%);
  animation: orbit3 5s linear infinite;
}

@keyframes orbit3 {
  from {
    transform: rotate(0deg) translateX(100px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(100px) rotate(-360deg);
  }
}

.vectorone-outline-1 {
  height: 200px;
  width: 200px;
}

.Vectorfour {
  height: 50px;
  width: 50px;
  background-image: url(../../assets/wema-faith/Vectorfour.svg);
  background-size: 100%;
  border-radius: 50%;
  position: absolute;
  left: 45%;
  top: 45%;
  /* box-shadow: -4px 2px 56px #c6c6c6; */
  transform: translate(-50%, -50%);
  animation: orbit9 50s linear infinite;
}

@keyframes orbit9 {
  from {
    transform: rotate(0deg) translateX(250px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(250px) rotate(-360deg);
  }
}

.Vectorfour-outline-1 {
  height: 500px;
  width: 500px;
}
.Vectorthree {
  height: 40px;
  width: 40px;
  /* background: #4ff005; */
  background-image: url(../../assets/wema-faith/Vectorthree.svg);
  background-size: 100%;
  /* border-radius: 50%; */
  position: absolute;
  left: 45%;
  top: 45%;
  /* box-shadow: -4px 2px 56px #c6c6c6; */
  transform: translate(-50%, -50%);
  animation: orbit7 20s linear infinite;
}

@keyframes orbit7 {
  from {
    transform: rotate(360deg) translateX(217px) rotate(-360deg);
  }
  to {
    transform: rotate(0deg) translateX(217px) rotate(0deg);
  }
}

.Vectorthree-outline-1 {
  height: 430px;
  width: 430px;
}
.Vectortwo {
  height: 50px;
  width: 50px;
  /* background: #cd05f0; */
  background-image: url(../../assets/wema-faith/Donation.svg);
  background-size: 100%;
  border-radius: 50%;
  position: absolute;
  left: 46.5%;
  top: 46.5%;
  /* box-shadow: -4px 2px 56px #fea535; */
  transform: translate(-50%, -50%);
  animation: orbit6 30s linear infinite;
}

@keyframes orbit6 {
  from {
    transform: rotate(0deg) translateX(185px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(185px) rotate(-360deg);
  }
}

.Vectortwo-outline-1 {
  height: 370px;
  width: 370px;
}

.vectorfive {
  height: 50px;
  width: 50px;
  /* background: #f0cd05; */
  background-image: url(../../assets/wema-faith/Vectorfive.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 50%;
  position: absolute;
  left: 44%;
  top: 43%;
  /* box-shadow: -4px 2px 56px #c6c6c6; */
  transform: translate(-50%, -50%);
  animation: orbit4 5s linear infinite;
}

@keyframes orbit4 {
  from {
    transform: rotate(360deg) translateX(150px) rotate(-360deg);
  }
  to {
    transform: rotate(0deg) translateX(150px) rotate(0deg);
  }
}

.vectorfive-outline-1 {
  height: 300px;
  width: 300px;
}

.vectorfive-circle {
  height: 65px;
  width: 65px;
  border: 1px dotted #900a39;
  border-radius: 40px;
  position: relative;
  left: -8px;
  top: -8px;
}
.vectorfive-inner {
  height: 10px;
  width: 10px;
  background-color: #900a39;
  border-radius: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  left: 45%;
  top: 45%;
  animation: orbit5 3s linear infinite;
}

@keyframes orbit5 {
  from {
    transform: rotate(0deg) translateX(33px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(33px) rotate(-360deg);
  }
}

/* p{
    color: white;
    font-family: system-ui;
    position: absolute;
    left: -62px;
    top: -11px;
} */

.vectorfive-outline-1,
.Vectortwo-outline-1,
.Vectorthree-outline-1,
.Vectorfour-outline-1,
.vectorone-outline-1 {
  border-radius: 50%;
  border: 1px solid #ddd9;
  position: absolute;
  z-index: -999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>